<template>
  <div class="pa-3 pb-1 wrapper" :class="{ right: right }">
    <div class="ma-1">
      <HiAvatar :uid="comment.user"></HiAvatar>
    </div>
    <div
      class="message ma-1"
      :class="{ right: right }"
      :style="{ backgroundColor: color }"
    >
      <div class="datetime">
        <span
          v-if="comment.action"
          style="font-style: normal;background-color: #aaaaaa;border-radius: 3px;padding-right: 3px;padding-left: 3px;margin-right:10px;color:white"
          >{{ actions[comment.action] }}
        </span>
        {{ comment.dateCreated | timestamp(true) }}
        <v-icon
          v-if="editable"
          style="font-size:9px"
          class="clickable"
          @click="goEdit"
          >mdi-border-color</v-icon
        >
      </div>
      <div v-html="comment.message">
        <!--        {{ comment.message }}-->
      </div>
    </div>

    <DLEditor ref="editor" title="Edit your post" @save="save"></DLEditor>
  </div>
</template>

<script>
import { collections, DocHelper, meta } from "@/db";
import HiAvatar from "../components/HiAvatar";
import DLEditor from "@/components/DiEditor";
export default {
  name: "HiCommentBubble",
  components: {
    DLEditor,
    HiAvatar
  },
  props: {
    id: {
      type: String
    },
    right: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "white"
    },
    editable: {
      type: Boolean
    }
  },
  data() {
    return {
      comment: {},
      actions: {}
    };
  },
  methods: {
    goEdit() {
      this.$refs.editor.open(this.comment.message);
    },
    async save(html) {
      console.log(html);
      await new DocHelper("comments", this.id).update("message", html);
      // await collections.comments.doc(this.id).update({ message: html });
      this.$refs.editor.close();
    }
  },
  async mounted() {
    this.actions = await meta.leads.commentActions();
  },
  watch: {
    id: {
      immediate: true,
      handler(id) {
        if (!id) return;
        // console.log(id);
        this.$bind("comment", collections.comments.doc(id));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
// .root {
//   border-bottom: $light-divider;
//   display: flex;
// }
// .reverse {
//   flex-direction: row-reverse;
// }
// .user-section.left {
//   border-right: $light-divider;
//   padding-right: 12px;
// }
// .user-section.right {
//   border-left: $light-divider;
//   padding-left: 12px;
// }
// .message-section {
//   color: #333333;
// }
// .message-section.left {
//   padding-right: 12px;
//   text-align: right;
// }
// .message-section.right {
//   padding-left: 12px;
// }
// :style="{flexDirection: (right? 'row-reverse' : 'row'),justifyContent: (right?'flex-end':'flex-start')}"
.wrapper {
  display: flex;
  width: 100%;
}
.wrapper.right {
  // flex-direction: row-reverse;
  display: flex;
  flex-direction: row-reverse;
  // justify-content: flex-end;
}
.username {
  font-size: 9px;
  font-weight: bold;
  color: #999999;
}
.message {
  border-radius: 0 10px 10px 10px;
  background-color: white;
  max-width: 90%;
  padding: 5px 10px 10px;
  box-shadow: 1px 1px 2px rgba(68, 68, 68, 0.1);
  //word-break: break-all;
}
.message.right {
  border-radius: 10px 0 10px 10px;
}
.datetime {
  color: #999999;
  font-size: 10px;
  font-style: italic;
  margin-bottom: 5px;
}
::v-deep p {
  margin-bottom: 0 !important;
}
</style>
